import { getLocation } from '@weathernews/btos-javascript-modules/src/wniutil/gps.js'
import Swal from 'sweetalert2'

export class CustomLocationControl {
  constructor(japanBounds, tmpMarkerPosition) {
    this.japanBounds = japanBounds
    this.tmpMarkerPosition = tmpMarkerPosition
  }

  onAdd(map) {
    this._map = map
    this._container = document.createElement('div')
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group'

    if (!document.querySelector('#custom-geolocate-style')) {
      const style = document.createElement('style')
      style.id = 'custom-geolocate-style'
      style.textContent = `
        .custom-geolocate-icon {
          background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_search_off.svg');
          background-position: 50%;
          background-repeat: no-repeat;
          display: block;
          height: 100%;
          width: 100%;
        }
        .custom-geolocate-icon.active {
          background-image: url('https://gvs.weathernews.jp/onebox/radar/img/icon/icon_search_on.svg');
        }
      `
      document.head.append(style)
    }

    // ボタンをインスタンスのプロパティとして保持
    this._button = document.createElement('button')
    this._button.className = 'maplibregl-ctrl-geolocate'
    this._button.type = 'button'
    this._button.title = 'Find my location'
    this._button.setAttribute('aria-label', 'Find my location')
    this._button.setAttribute('aria-pressed', 'false')

    const iconSpan = document.createElement('span')
    iconSpan.className = 'custom-geolocate-icon'
    iconSpan.setAttribute('aria-hidden', 'true')
    this._button.append(iconSpan)

    this._button.addEventListener('click', () => this.locate())
    this._container.append(this._button)
    return this._container
  }

  async locate() {
    const iconSpan = this._button.querySelector('.custom-geolocate-icon')
    // 座標取得開始: loading true
    window.dispatchEvent(new CustomEvent('custom-geolocate-loading', { detail: { loading: true } }))
    try {
      const { lat, lon } = await getLocation({ enableHighAccuracy: false })
      this.tmpMarkerPosition.value = { lat, lon }
      if (iconSpan) iconSpan.classList.add('active')
      // ピンをGeoJSONで表示
      if (this._map.getSource('user-location')) {
        this._map.getSource('user-location').setData({
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: { type: 'Point', coordinates: [lon, lat] }
            }
          ]
        })
      }
      if (this._map.getSource('crosshair-vertical')) {
        this._map.getSource('crosshair-vertical').setData({
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: { type: 'LineString', coordinates: [
                [lon, this.japanBounds[0][1]],
                [lon, this.japanBounds[1][1]]
              ] }
            }
          ]
        })
      }
      if (this._map.getSource('crosshair-horizontal')) {
        this._map.getSource('crosshair-horizontal').setData({
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: { type: 'LineString', coordinates: [
                [this.japanBounds[0][0], lat],
                [this.japanBounds[1][0], lat]
              ] }
            }
          ]
        })
      }
      // 座標付きでイベント発火
      window.dispatchEvent(new CustomEvent('custom-geolocate', { detail: { lat, lon } }))
      window.dispatchEvent(new CustomEvent('custom-geolocate-loading', { detail: { loading: false } }))
      // 地図中心を現在地に移動
      this._map.flyTo({ center: [lon, lat], zoom: 11 })
    } catch {
      window.dispatchEvent(new CustomEvent('custom-geolocate-loading', { detail: { loading: false } }))
      if (iconSpan) iconSpan.classList.remove('active')
      // sweetalert2でアラート表示
      Swal.fire({
        icon: 'error',
        title: '位置情報の取得に失敗しました',
        text: '位置情報の取得が許可されているかご確認ください。',
        confirmButtonText: 'OK'
      })
    }
  }

  deactivate() {
    if (this._button) {
      const iconSpan = this._button.querySelector('.custom-geolocate-icon')
      if (iconSpan) iconSpan.classList.remove('active')
    }
  }

  onRemove() {
    this._container.remove()
    this._map = undefined
  }
}
